import * as React from 'react'
import { TechnicalOrder } from '@models/technical-orders'
import { useTechnicalOrderPreviewModal } from '@modules/technical-orders/hooks/use-technical-order-preview-modal'
import Table from '@components/table/table'
import { TechnicalOrdersTodoRowNumber } from '@modules/technical-orders/technical-orders-todo/row-number'
import { TechnicalOrdersTodoRowUnit } from '@modules/technical-orders/technical-orders-todo/row-unit'
import { TechnicalOrdersTodoRowName } from '@modules/technical-orders/technical-orders-todo/row-name'
import { TechnicalOrdersTodoRowUserBy } from '@modules/technical-orders/technical-orders-todo/row-user-by'
import { ReceptionTechnicalOrdersTableRowActions } from '@modules/reception-technical-orders/row-actions'
import { TechnicalOrdersTodoRowStatus } from '@modules/reception-technical-orders/row-status'
import { TechnicalOrdersTodoRowUsers } from '@modules/technical-orders/technical-orders-ordered/row-users'
import { TechnicalOrdersNotes } from '@modules/technical-orders/technical-orders-ordered/row-notes-content'

interface Props {
  technicalOrder: TechnicalOrder
  showUsers: boolean
}

export const ReceptionTechnicalOrdersTableRow: React.FC<Props> = ({ technicalOrder, showUsers }) => {
  const handlePreview = useTechnicalOrderPreviewModal({ technicalOrder })

  return (
    <Table.Row onDoubleClick={handlePreview} className="cursor-pointer">
      <TechnicalOrdersTodoRowNumber technicalOrder={technicalOrder} width={200} />
      <TechnicalOrdersTodoRowUnit technicalOrder={technicalOrder} width={200} />
      <TechnicalOrdersTodoRowStatus technicalOrder={technicalOrder} width={200} />
      <TechnicalOrdersTodoRowName technicalOrder={technicalOrder} width={300} />
      <TechnicalOrdersTodoRowUserBy
        user={technicalOrder.created_by}
        booking={technicalOrder.created_by_booking}
        isCreatedByClient={technicalOrder.is_created_by_client}
        width={200}
      />
      {showUsers && <TechnicalOrdersTodoRowUsers technicalOrder={technicalOrder} width={250} />}
      <ReceptionTechnicalOrdersTableRowActions technicalOrder={technicalOrder}>
        <TechnicalOrdersNotes technicalOrder={technicalOrder} />
      </ReceptionTechnicalOrdersTableRowActions>
    </Table.Row>
  )
}
